// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CheckoutReviewTerms } from "@guestsupply/App/Handlers/XNG/CheckoutReviewTerms";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import { Draft } from "immer";

export type CheckoutReviewTermsState = Readonly<{
    isChecked: boolean;
}>;

const initialState: CheckoutReviewTermsState = {
    isChecked: false,
};
const reducer = {
    "xCheckoutReviewTerms/SetIsChecked": (
        draft: Draft<CheckoutReviewTermsState>,
        action: { data: CheckoutReviewTerms },
    ) => {
        draft.isChecked = action.data.isChecked;
    },
};

const xCheckoutReviewTerms = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xCheckoutReviewTerms = xCheckoutReviewTerms;

export type xCheckoutReviewTermState = {
    xCheckoutReviewTerms: CheckoutReviewTermsState;
} & ApplicationState;

type CheckoutReviewTermsReducers = {
    isChecked: typeof xCheckoutReviewTerms;
};

export type xCheckoutReviewTerms =
    | Parameters<CheckoutReviewTermsReducers[keyof CheckoutReviewTermsReducers]>[1]
    | AnyAction;
